// Admin user configuration
export const ADMIN_EMAILS = ["heiko.nagl@hotmail.de", "sascha.dumke@gmail.com"];

// Settings constants
export const SETTINGS_DEFAULTS = {
  MIN_DART_ROUNDS: 10,
};

// UI Constants
export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};
